import React, { useMemo, useState } from "react";
// Types
import { GetAnimalsList_animalsExtended_animals } from "api/MyLivestock/Animal/types/GetAnimalsList";
// Components
import { ConfirmAddPreviousKeeperModal } from "./ConfirmAddPreviousKeeperModal";
import { AddSelectedAnimalsToGroup } from "./AddSelectedAnimalsToGroup";
import { ConfirmMarkOffFarmModal } from "./ConfirmMarkOffFarmModal";
import { CreateListingFromSelection } from "./CreateListingFromSelection";
import ConfirmMoveToFieldModal from "./ConfirmMoveToFieldModal";
import { LogActivityModal } from "./LogActivityModal";
import { Button, Flex } from "components";
// Utils
import { ELEMENTS_IDS } from "constants/ElementsIds";
import { MarkAsDeadModal } from "animals/MarkAsDeadModal";
import { AddSelectedAnimalsToTag } from "./AddSelectedAnimalsToTag";
import { RemoveSelectedAnimalsToTag } from "./RemoveSelectedAnimalsToTag";

interface AnimalBulkActionsProps {
  animals: GetAnimalsList_animalsExtended_animals[];
  tableId: string;
}

export const AnimalBulkActions: React.FC<AnimalBulkActionsProps> = ({ animals = [], tableId }) => {
  const [showMoveToFieldConfirmation, setVisibleMoveToFieldConfirmation] = useState(false);
  const [showMarkAsDeadModal, setShowMarkAsDeadModal] = useState(false);

  const animalIds = useMemo(() => animals.map((animal) => animal.id), [animals]);

  const handleMoveAnimalToFieldClick = (): void => setVisibleMoveToFieldConfirmation(true);
  const handleMoveAnimalToFieldClose = (): void => setVisibleMoveToFieldConfirmation(false);

  return (
    <Flex container containerJustifyContent="flex-end" xs="fill">
      <Flex item itemGutter>
        <ConfirmAddPreviousKeeperModal animals={animals} />
      </Flex>

      <Flex item>
        <CreateListingFromSelection animals={animals} />
      </Flex>

      <Flex item itemGutter>
        <AddSelectedAnimalsToTag animalIds={animalIds} />
      </Flex>

      <Flex item itemGutter>
        <RemoveSelectedAnimalsToTag animalIds={animalIds} />
      </Flex>

      <Flex item itemGutter>
        <AddSelectedAnimalsToGroup animalIds={animalIds} />
      </Flex>

      <Flex item>
        <ConfirmMarkOffFarmModal animals={animals} tableId={tableId} />
      </Flex>

      <Flex item itemGutter>
        <Button caption="Mark as dead" onClick={() => setShowMarkAsDeadModal(true)} />
        {showMarkAsDeadModal && (
          <MarkAsDeadModal
            onClose={() => setShowMarkAsDeadModal(false)}
            animalIds={animalIds}
            showModal={showMarkAsDeadModal}
          />
        )}
      </Flex>

      <Flex item>
        <Button
          caption={"Move to location"}
          id={ELEMENTS_IDS.ANIMALS_MOVE_TO_FIELD_BUTTON}
          onClick={handleMoveAnimalToFieldClick}
        />

        <ConfirmMoveToFieldModal
          animals={animalIds}
          onClose={handleMoveAnimalToFieldClose}
          showModal={showMoveToFieldConfirmation}
        />
      </Flex>

      <Flex item itemGutter>
        <LogActivityModal animals={animals} />
      </Flex>
    </Flex>
  );
};
